/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Aroma_Sampling_Delete_ErrorInputs */

const vi_toast_aroma_sampling_delete_error = /** @type {(inputs: Toast_Aroma_Sampling_Delete_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa lần lấy hương thất bại`)
};

/**

* @param {Toast_Aroma_Sampling_Delete_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_aroma_sampling_delete_error = /** @type {((inputs?: Toast_Aroma_Sampling_Delete_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Aroma_Sampling_Delete_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_aroma_sampling_delete_error(inputs)
});